// extracted by mini-css-extract-plugin
export default {"container":"InfoAlert_container__ytfqc"};